// @core/api/endpoints/project/update_project.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProjectResponse,
  UpdateProjectRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update project
 * Updates project settings including name, description, and configuration options. Requires admin privileges on the project.
 */
export async function UpdateProject(
  project_id: string,
  data: UpdateProjectRequest,
  options?: RequestOptions
): Promise<ProjectResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.put<ProjectResponse>(requestPath, data, requestOptions);
}
